import tippy from 'tippy.js';

const dataMobile = document.querySelector('.m-data-attributes-mobile');
const subList = document.querySelector('.m-data-attributes-mobile__sublist');

function initDataMobilePage() {

    const searchBox = document.getElementById("m-data-attributes__search-mobile");
    const searchBoxExit = document.querySelector(".m-data-attributes__stop-search--mobile");
    const container = document.querySelector('.m-data-attributes-mobile');
    const dropdownItems = document.querySelectorAll('.m-data-attributes-mobile__dropdown-item');
    const dropdownItemsContent = document.querySelectorAll('.m-data-attributes-mobile__dropdown-content');
    const subDropdownItems = document.querySelectorAll('.m-data-attributes-mobile__sublist-item');
    const subDropdownItemsHeaders = document.querySelectorAll('.m-data-attributes-mobile__sublist-header');
    let debounceTimer;

    const debounce = (time, evt) => {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function() {
          search(evt.target.value);
        }, time)
    };

    dropdownItems.forEach(function(dropdown){
        dropdown.addEventListener('click', function(){
            openDropdown(dropdown);
        });
    }); 

    subDropdownItemsHeaders.forEach(function(dropdown){
        dropdown.addEventListener('click', function(){
            openSubDropdown(dropdown);
        });
    }); 

    searchBoxExit.addEventListener('click', () => {
      resetSearchBox();
    })

    searchBox.addEventListener('keyup', (evt) => {
        debounce(400, evt);
    })

    function resetSearchBox() {
      searchBox.value = '';
      
      if(container.classList.contains('search-active')) {
        container.classList.remove('search-active');
      }
  
      resetSearchListItems();
    }

    function resetSearchListItems() {
        subDropdownItems.forEach((item) => {
          if (item.classList.contains('hidden')) {
            item.classList.remove('hidden');
          }
        });
      }

    function openDropdown(dropdown) {

        dropdownItemsContent.forEach(function(item){ 
            if(item.dataset.dropdown == dropdown.dataset.dropdown) {
                item.classList.toggle('visible');
            } 
        });
    }

    function openSubDropdown(dropdown) {
        dropdown.parentElement.classList.toggle('visible');
    }
    
    const buttons = document.querySelectorAll('.e-tooltip-btn');

    Array.from(buttons).forEach((button) => {
        tippy(button, {
            content: button.getAttribute('data-tippy'),
            theme: 'light-border',
            trigger: 'click',
            offset: [0, 18],
        });
    });

    function search(str) {

        var searchStr = str.toLowerCase();
    
        var nResults = 0;

        if(searchStr === '') {
      
            if(container.classList.contains('search-active')) {
                container.classList.remove('search-active');
            }
      
            resetSearchListItems();
      
            return;
        }
    
        if(!container.classList.contains('search-active')) {
        container.classList.add('search-active');
        }
    
        subDropdownItems.forEach((row) => {
    
          var cells = row.querySelectorAll('div[data-searchable="1"]');
    
          if (cells.length === 0) {
            return;
          }
    
          var found = false;
    
          cells.forEach((cell) => {
            if(cell.textContent.toLowerCase().indexOf(searchStr) !== -1) {
              found = 1;
              return;
            }
          });
    
          if(found) {
            row.classList.remove('hidden');
            nResults++;
          } else {
            row.classList.add('hidden');
          }
    
        });

    }
}   

if (dataMobile && subList) {
    initDataMobilePage();
}


